import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
  Typography,
} from '@mui/material';
import { Stack } from '@mui/system';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { permissions } from 'src/paths';
import { editTaskTimeAction, resetEditTaskTimeAction } from 'src/redux/actions/editTaskTimeAction';

const { UPDATE_DAILY_TASK } = permissions;

type Props = {
  handleEditTimeDialog: any;
  providerId: string;
  handleDeleteMinuteZero?: any;
  therapyInfo?: any;
};

function EditTaskTime(props: Props) {
  const [numberOfMins, setNumberOfMins] = useState(props.therapyInfo?.numberOfMinutes);
  const isNumber = !isNaN(numberOfMins) && numberOfMins !== '';
  const dispatch = useDispatch();
  const permissionData = useSelector(
    (state: any) => state?.getTherapistProfileReducer?.response?.data?.currentPermissions
  );
  function isString(value: any) {
    return typeof value === 'string';
  }

  const { isTimeEdited } = useSelector((state: any) => state.editTaskTimeReducer);

  const handleSubmit = () => {
    dispatch(
      editTaskTimeAction({
        providerId: props.providerId,
        taskId: isString(props.therapyInfo.taskId)
          ? [props.therapyInfo.taskId]
          : props.therapyInfo.taskId,
        time: numberOfMins,
        taskType: props.therapyInfo.taskType,
        isAssigned: props?.therapyInfo.isAssigned || false,
        requestBody: {
          taskUuids:
            props.therapyInfo.taskType === 'task-uuid'
              ? isString(props.therapyInfo.taskId)
                ? [props.therapyInfo.taskId]
                : props.therapyInfo.taskId
              : null,
          groupUuid: props.therapyInfo.taskType === 'group-uuid' ? props.therapyInfo.taskId : null,
        },
      })
    );
  };

  useEffect(() => {
    if (isTimeEdited && +numberOfMins === 0) {
      props?.handleDeleteMinuteZero && props?.handleDeleteMinuteZero();
      dispatch(resetEditTaskTimeAction());
    }
  }, [isTimeEdited, numberOfMins]);

  return (
    <Grid
      width={600}
      container
      flexDirection={'column'}
      gap={'5px'}
    >
      <DialogTitle
        sx={{ m: 0, p: 2 }}
        id="customized-dialog-title"
      >
        <Typography
          sx={{
            fontSize: '1rem',
            fontWeight: 600,
            lineHeight: 1.4,
          }}
        >
          Edit Task Minutes
        </Typography>
      </DialogTitle>
      <DialogContent
        sx={{
          paddingBottom: '0px !important',
        }}
      >
        <Stack>
          {['CONCURRENT', 'THERAPY', 'GROUP_THERAPY'].includes(
            props?.therapyInfo?.therapyType || ''
          ) && (
            <Typography
              sx={{ marginBottom: '12px' }}
              variant="body1"
            >
              The updated minutes will reflect in the Therapy Planning screen
            </Typography>
          )}
        </Stack>
        <Stack>
          <TextField
            fullWidth
            label="Number of Minutes"
            name="numberOfMinutes"
            value={numberOfMins}
            onChange={(e) => {
              const value = e.target.value;
              if (/^\d*$/.test(value)) {
                setNumberOfMins(value);
              }
            }}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button
          autoFocus
          onClick={props.handleEditTimeDialog}
        >
          Cancel
        </Button>
        <Button
          autoFocus
          variant="contained"
          type="submit"
          disabled={!isNumber || !permissionData?.includes(UPDATE_DAILY_TASK)}
          onClick={handleSubmit}
        >
          Update
        </Button>
      </DialogActions>
    </Grid>
  );
}

export default EditTaskTime;
